import AttributePreviewView from "../views/attributePreview.view.html";
import AttributePreviewImageView from "../views/attributePreviewImage.view.html";

export default class AttributePreviewDirective {
    constructor($uibModal) {
        this.restrict = 'A';
        this.scope = {
            file: '='
        };
        this.$uibModal = $uibModal;
        this.template = AttributePreviewView;
        this.displayPreview = false;
        this.transclude = true;
    }

    link(scope, element, attrs) {

        scope.displayPreview = false;
        scope.hover = false;

        scope.openPreview = () => {
            let modalInstance = this.$uibModal.open({
                animation: 'false',
                size: 'lg',
                template: AttributePreviewImageView,
                controller: 'AttributePreviewImageController',
                windowClass: 'attribute-preview-image',
                backdropClass: 'product-large-image',
                resolve: {
                    file: function () {
                        return scope.file;
                    },
                    parent: this
                }
            });

            modalInstance.result.then(() => {}, () => {});
        }
    }

    static directiveFactory($uibModal) {
        'ngInject';

        return new AttributePreviewDirective($uibModal);
    }
}
